import { render, staticRenderFns } from "./partners.component.vue?vue&type=template&id=d399f74e&scoped=true"
import script from "./partners.component.vue?vue&type=script&lang=js"
export * from "./partners.component.vue?vue&type=script&lang=js"
import style0 from "./partners.component.vue?vue&type=style&index=0&id=d399f74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d399f74e",
  null
  
)

export default component.exports